import { render, staticRenderFns } from "./ChnagePasswordView.vue?vue&type=template&id=769a6f25&scoped=true&"
import script from "./ChnagePasswordView.vue?vue&type=script&lang=ts&"
export * from "./ChnagePasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ChnagePasswordView.vue?vue&type=style&index=0&id=769a6f25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a6f25",
  null
  
)

export default component.exports